module.exports = __webpack_public_path__ + "static/img/wrong_top.6a7765a4.jpg";